(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4032],{

/***/ 87517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports loginSendOTP, loginVerifyOTP */
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_contactPigeon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87154);





var baseURL = "".concat("https://kritikos-cxm-production.herokuapp.com", "/auth");
var AUTH = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
  baseURL: baseURL,
  headers: {
    appId: "kritikos-web"
  }
});
function loginSendOTP(_x, _x2) {
  return _loginSendOTP.apply(this, arguments);
}
/**
 * @returns User object or undefined
 */

function _loginSendOTP() {
  _loginSendOTP = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(number, type) {
    var response;
    return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return AUTH.get("/sms/confirmation/".concat(type, "/").concat(number));

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", Promise.reject(_context.t0));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _loginSendOTP.apply(this, arguments);
}

function loginVerifyOTP(_x3) {
  return _loginVerifyOTP.apply(this, arguments);
}

function _loginVerifyOTP() {
  _loginVerifyOTP = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(body) {
    var response, user, _error$response;

    return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return AUTH.post('/sms/login', body);

          case 3:
            response = _context2.sent;
            user = lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(response, 'data.payload.users');

            if (user) {
              _context2.next = 8;
              break;
            }

            console.error(response);
            throw Error('No user found in response.');

          case 8:
            (0,_utils_contactPigeon__WEBPACK_IMPORTED_MODULE_4__/* .updateUser */ .N)(user.email);
            return _context2.abrupt("return", user);

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", _context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 12]]);
  }));
  return _loginVerifyOTP.apply(this, arguments);
}

/* harmony default export */ __webpack_exports__["ZP"] = ({
  loginSendOTP: loginSendOTP,
  loginVerifyOTP: loginVerifyOTP
});

/***/ }),

/***/ 3805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ PrimaryButton; },
/* harmony export */   "hG": function() { return /* binding */ BrandButton; },
/* harmony export */   "kq": function() { return /* binding */ SecondaryButton; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88154);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "onClick"],
    _excluded2 = ["children", "onClick"],
    _excluded3 = ["children", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function PrimaryButton(_ref) {
  var children = _ref.children,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().primaryButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}
function BrandButton(_ref2) {
  var children = _ref2.children,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref2, _excluded2);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().brandButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}
function SecondaryButton(_ref3) {
  var children = _ref3.children,
      _ref3$onClick = _ref3.onClick,
      onClick = _ref3$onClick === void 0 ? function () {} : _ref3$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().secondaryButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}

/***/ }),

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 10625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainLogo; }
/* harmony export */ });
/* harmony import */ var _MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61680);
/* harmony import */ var _MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


function MainLogo() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
    className: (_MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1___default().logo),
    width: "160",
    height: "56",
    src: "/assets/".concat("kritikos", "/logo.svg"),
    alt: "".concat("kritikos", " logo"),
    "data-cy": "logo"
  });
}

/***/ }),

/***/ 91320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OTPView; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(51649);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(79352);
/* harmony import */ var react_otp_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71470);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65885);
/* harmony import */ var _api_wave_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87517);
/* harmony import */ var _api_wave_orders__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89798);
/* harmony import */ var _api_wave_users__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71231);
/* harmony import */ var _store_authModalShow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24001);
/* harmony import */ var _store_guestUser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42604);
/* harmony import */ var _store_loader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58766);
/* harmony import */ var _store_user__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73471);
/* harmony import */ var _utils_verifications__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15471);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3805);
/* harmony import */ var _OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(88416);
/* harmony import */ var _OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);
// import TextField from '@mui/material/TextField';




















function OTPView(_ref) {
  var method = _ref.method,
      userId = _ref.userId,
      _ref$successCallback = _ref.successCallback,
      successCallback = _ref$successCallback === void 0 ? function () {} : _ref$successCallback,
      children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    otp: ''
  }),
      otpInputsValues = _useState[0],
      setOtpInputsValues = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      errorMsg = _useState2[0],
      setErrorMsg = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      mobileNumber = _useState3[0],
      setMobileNumber = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      resendOtpErrorMessage = _useState4[0],
      setResendOtpErrorMessage = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      resendOtpSuccessMessage = _useState5[0],
      setResendOtpSuccessMessage = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      user = _useState6[0],
      setUser = _useState6[1];

  var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z();

  function onChangeOTP(otp) {
    setErrorMsg('');
    setOtpInputsValues({
      otp: otp
    });
  }

  function createTokenCookie(authToken) {
    var cookieExpirationDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()().add(15, 'day').toDate();
    cookies.set('token', "".concat(authToken), {
      expires: cookieExpirationDate,
      path: '/'
    });
  }

  function verifyOTPWrapper(callback) {
    // setIsLoginCallBeingMade(true);
    var data = {
      code: otpInputsValues.otp,
      verificationToken: _store_authModalShow__WEBPACK_IMPORTED_MODULE_8__/* .AuthVerificationToken.getValue */ .I0.getValue() || userId
    };
    _store_loader__WEBPACK_IMPORTED_MODULE_10__/* ["default"].addEvent */ .Z.addEvent('VERIFY_OTP');
    callback(data).then(function (response) {
      if (response !== null && response !== void 0 && response.error) {
        var _response$error;

        setErrorMsg(response === null || response === void 0 ? void 0 : (_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.userMessage); // setIsLoginCallBeingMade(false);

        return;
      }

      createTokenCookie(response.token);
      _store_user__WEBPACK_IMPORTED_MODULE_11__/* ["default"].update */ .Z.update(response);
      _api_wave_orders__WEBPACK_IMPORTED_MODULE_6__/* .ORDER.defaults.headers.authorization */ .kl.defaults.headers.authorization = "Bearer ".concat(response.token);
      _store_authModalShow__WEBPACK_IMPORTED_MODULE_8__/* .AuthModal.update */ .Qb.update(false);
      _store_authModalShow__WEBPACK_IMPORTED_MODULE_8__/* .AuthModalView.update */ .Rt.update('login'); // setIsLoginCallBeingMade(false);

      _store_authModalShow__WEBPACK_IMPORTED_MODULE_8__/* .AuthVerificationToken.update */ .I0.update('');

      if (method === 'login') {
        next_router__WEBPACK_IMPORTED_MODULE_2___default().push('/', '/');
      } else {
        successCallback();
      }
    }).catch(function (error) {
      console.error(JSON.stringify(error, null, 2));
      setErrorMsg(error.error.userMessage);
    }).finally(function () {
      _store_guestUser__WEBPACK_IMPORTED_MODULE_9__/* ["default"].setInitUser */ .Z.setInitUser();
      _store_loader__WEBPACK_IMPORTED_MODULE_10__/* ["default"].removeEvent */ .Z.removeEvent('VERIFY_OTP');
    });
  }

  function requestOTP() {
    setErrorMsg('');

    var _id = userId || _store_authModalShow__WEBPACK_IMPORTED_MODULE_8__/* .AuthVerificationToken.getValue */ .I0.getValue() || mobileNumber;

    var numberIdNoSpace = _id.replace(/\s/g, '');

    _store_loader__WEBPACK_IMPORTED_MODULE_10__/* ["default"].addEvent */ .Z.addEvent('RESEND_TOP');
    var verificationMethod = _utils_verifications__WEBPACK_IMPORTED_MODULE_12__/* ["default"].isGreekNumber */ .ZP.isGreekNumber(numberIdNoSpace) ? 'mobile' : 'card';
    _api_wave_auth__WEBPACK_IMPORTED_MODULE_5__/* ["default"].loginSendOTP */ .ZP.loginSendOTP(numberIdNoSpace, verificationMethod).then(function (response) {
      setMobileNumber(response.payload.verification.verificationToken);
      setResendOtpErrorMessage('');
      setResendOtpSuccessMessage('Ο κωδικός έχει αποσταλεί ξανά.');
      setTimeout(function () {
        setResendOtpSuccessMessage('');
      }, 3000);
    }).catch(function (error) {
      var errorMessage = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(error, 'response.data.error.userMessage', 'Δεν ήταν δυνατό να αποσταλεί ο κωδικός.');
      setResendOtpSuccessMessage('');
      setResendOtpErrorMessage({
        errorMessage: errorMessage
      });
    }).finally(function () {
      _store_loader__WEBPACK_IMPORTED_MODULE_10__/* ["default"].removeEvent */ .Z.removeEvent('RESEND_TOP');
    });
  }

  function onSubmitOTP(e) {
    e.preventDefault();

    if (method === 'login' || method === 'login-digital') {
      verifyOTPWrapper(_api_wave_auth__WEBPACK_IMPORTED_MODULE_5__/* ["default"].loginVerifyOTP */ .ZP.loginVerifyOTP);
    } else {
      verifyOTPWrapper(_api_wave_users__WEBPACK_IMPORTED_MODULE_7__/* ["default"].verifyCode */ .ZP.verifyCode);
    }
  }

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var _user = _store_user__WEBPACK_IMPORTED_MODULE_11__/* ["default"].getValue */ .Z.getValue();

    setUser(_user);
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("section", {
    className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().container),
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("div", {
      className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().imageContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("img", {
        className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().img),
        width: "200",
        height: "200",
        src: "/assets/".concat("kritikos", "/").concat("kritikos", "-login.png"),
        alt: "grocery app"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("p", {
      className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().p),
      children: ["\u03A3\u03BF\u03C5 \u03AD\u03C7\u03BF\u03C5\u03BC\u03B5 \u03C3\u03C4\u03B5\u03AF\u03BB\u03B5\u03B9 \u03AD\u03BD\u03B1\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03BC\u03B5 SMS \u03C3\u03C4\u03BF ", user === null || user === void 0 ? void 0 : user.maskedMobile, ", \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03C3\u03C5\u03BC\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B5 \u03C4\u03BF\u03BD \u03B5\u03B4\u03CE."]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("form", {
      noValidate: true,
      className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().form),
      onSubmit: onSubmitOTP,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("div", {
        className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().otpContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(react_otp_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          isInputNum: true,
          inputStyle: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().otpInput),
          hasErrored: Boolean(errorMsg),
          errorStyle: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().otpError),
          "data-cy": "otp",
          value: otpInputsValues.otp,
          onChange: onChangeOTP,
          numInputs: 6,
          shouldAutoFocus: true,
          separator: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("span", {
            className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().separator),
            children: " "
          })
        })
      }), errorMsg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", {
        className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().errorMsg),
        children: errorMsg
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("div", {
        className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().primaryButtonContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_13__/* .PrimaryButton */ .KM, {
          type: "submit",
          "data-cy": "log-in",
          style: {
            width: '100%'
          },
          children: "\u0395\u03AF\u03C3\u03BF\u03B4\u03BF\u03C2"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("div", {
      className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().flexCenter),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", {
        className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().footerText),
        children: "\u0394\u03B5\u03BD \u03C3\u03B1\u03C2 \u03AE\u03C1\u03B8\u03B5 \u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2; "
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("button", {
        type: "button",
        className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().footerButton),
        onClick: requestOTP,
        children: "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BE\u03B1\u03BD\u03AC"
      })]
    }), resendOtpErrorMessage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("p", {
      className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().resendOtpErrorMessage),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_17__/* .RiErrorWarningLine */ .j6O, {
        className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().resendIcon)
      }), " ", resendOtpErrorMessage]
    }), resendOtpSuccessMessage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("p", {
      className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().resendOtpSuccessMessage),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_18__/* .IoMdCheckmarkCircleOutline */ .osu, {
        className: (_OTPView_module_scss__WEBPACK_IMPORTED_MODULE_16___default().resendIcon)
      }), resendOtpSuccessMessage]
    })]
  });
}

/***/ }),

/***/ 24001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I0": function() { return /* binding */ AuthVerificationToken; },
/* harmony export */   "Qb": function() { return /* binding */ AuthModal; },
/* harmony export */   "Rt": function() { return /* binding */ AuthModalView; },
/* harmony export */   "u": function() { return /* binding */ AuthFavoriteModal; }
/* harmony export */ });
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20090);

var subjectShowAuthModal = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(false);
var subjectShowFavoriteAuthModal = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(false);
var subjectAuthModalView = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X('login');
var subjectAuthVerificationToken = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X('');
var meta = {
  fetched: false,
  updatedAt: new Date()
};

function onFetch() {
  Object.assign(meta, {
    fetched: true,
    updatedAt: new Date()
  });
}

var AuthModal = {
  update: function update(authModal) {
    subjectShowAuthModal.next(authModal);
    onFetch();
  },
  subscribe: function subscribe(setState) {
    return subjectShowAuthModal.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectShowAuthModal.value;
  }
};
var AuthModalView = {
  update: function update(authModalView) {
    subjectAuthModalView.next(authModalView);
    onFetch();
  },
  subscribe: function subscribe(setState) {
    return subjectAuthModalView.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectAuthModalView.value;
  }
};
var AuthFavoriteModal = {
  update: function update(authModal) {
    subjectShowFavoriteAuthModal.next(authModal);
    onFetch();
  },
  subscribe: function subscribe(setState) {
    return subjectShowFavoriteAuthModal.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectShowFavoriteAuthModal.value;
  }
};
var AuthVerificationToken = {
  update: function update(verificationToken) {
    subjectAuthVerificationToken.next(verificationToken);
    onFetch();
  },
  subscribe: function subscribe(setState) {
    return subjectAuthVerificationToken.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectAuthVerificationToken.value;
  }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  AuthModal: AuthModal,
  AuthModalView: AuthModalView,
  AuthFavoriteModal: AuthFavoriteModal,
  AuthVerificationToken: AuthVerificationToken
});

/***/ }),

/***/ 42604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20090);
/* harmony import */ var _utils_json_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19022);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var initialState = {
  email: '',
  contactPhone: '',
  city: '',
  nameAtBell: '',
  floor: '',
  postalCode: '',
  street: '',
  streetNo: ''
};
var GuestUserStore = {
  subject: null,
  _lazyInit: function _lazyInit() {
    if (GuestUserStore.subject) return GuestUserStore.subject;
    var storage = window.sessionStorage;
    var guestUser = _utils_json_storage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('guestUser', {
      storage: storage
    });
    GuestUserStore.subject = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(guestUser);
    return GuestUserStore.subject;
  },
  update: function update(guest) {
    var guestNext = _objectSpread(_objectSpread({}, GuestUserStore.getValue()), guest);

    var guestUser = GuestUserStore._lazyInit();

    guestUser.next(guestNext);
    var storage = window.sessionStorage;
    _utils_json_storage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .ZP.set('guestUser', guestNext, {
      storage: storage
    });
  },
  subscribe: function subscribe(setState) {
    var guestUser = GuestUserStore._lazyInit();

    return guestUser.subscribe(setState);
  },
  getValue: function getValue() {
    var guestUser = GuestUserStore._lazyInit();

    return guestUser.value;
  },
  setInitUser: function setInitUser() {
    GuestUserStore.update(initialState);
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (GuestUserStore);

/***/ }),

/***/ 65168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ theme; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21265);
/* harmony import */ var _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65447);
/* harmony import */ var _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
  typography: {
    fontFamily: _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1__.brandFontFamily
  }
});

/***/ }),

/***/ 15471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports isGreekNumber, isCardNumber */
function isGreekNumber(value) {
  return value && /^(\+30|0030)?69\d{8}$/.test(value.replace(/[\s\-().]/g, ''));
}
function isCardNumber(value) {
  var parsePattern = new RegExp("^9618(\\d{8}|\\d{9})$");
  return value && parsePattern.test(value.replace(/[^0-9]/g, ''));
}
/* harmony default export */ __webpack_exports__["ZP"] = ({
  isGreekNumber: isGreekNumber,
  isCardNumber: isCardNumber
});

/***/ }),

/***/ 88154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons_button__qYN03","primaryButton":"Buttons_primaryButton__7N3x3","brandButton":"Buttons_brandButton__cCp9d","secondaryButton":"Buttons_secondaryButton__ruBI_"};

/***/ }),

/***/ 61680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainLogo_logo__zTYp1"};

/***/ }),

/***/ 88416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OTPView_container__udJkR","logoContainer":"OTPView_logoContainer__m5mM_","header":"OTPView_header__b1iok","imageContainer":"OTPView_imageContainer__Xzeky","img":"OTPView_img__OCXZ5","p":"OTPView_p__KzA_i","form":"OTPView_form__2Wv1s","primaryButtonContainer":"OTPView_primaryButtonContainer__Sx0bg","footerText":"OTPView_footerText__eBZrd","footerButton":"OTPView_footerButton__3aHvv","flexCenter":"OTPView_flexCenter__YZlnS","otpContainer":"OTPView_otpContainer__z20u3","otpBox":"OTPView_otpBox__NLZck","otpInput":"OTPView_otpInput__SbrL0","separator":"OTPView_separator__ISOuq","errorMsg":"OTPView_errorMsg__9FM5D","resendOtpMessage":"OTPView_resendOtpMessage__5Uh6o","resendOtpSuccessMessage":"OTPView_resendOtpSuccessMessage__q6TVa","resendOtpErrorMessage":"OTPView_resendOtpErrorMessage__W1kJu","otpError":"OTPView_otpError__LzDpx","resendIcon":"OTPView_resendIcon__sPQXU"};

/***/ }),

/***/ 65447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"brandFontFamily":"\"Roboto\",Helvetica,Arial,sans-serif","container":"layout_container__8mgcn","section":"layout_section__q1Enk","row":"layout_row___Mosi"};

/***/ })

}]);